import { Game } from "./types/Game";
import allTechniqueGameDescriptions, {
  GameDescription,
} from "./allTechniqueGameDescriptions";

export const getGameDescription = (game: Game): GameDescription => {
  const gameDescriptions = Object.values(allTechniqueGameDescriptions).map(
    (techniqueConfig) => techniqueConfig.games[game]
  );

  const gameDescription = gameDescriptions.find(
    (gameDescription) => gameDescription !== undefined
  );

  if (gameDescription === undefined) {
    throw new Error(`Game ${game} not found`);
  }

  return gameDescription;
};
